export default {
  postStatus: {
    draft: '草稿',
    published: '发布',
    recycled: "垃圾"
  },
  sex: {
    male: '男',
    female: '女',
    unknown: '未知'
  }
}
